import React, { useEffect, useState } from 'react';
import PayrollLayout from '../../layouts/PayrollLayout';

export default function SalaryDisbursement() {
  const [payouts, setPayouts] = useState([]);
  const [filteredStatus, setFilteredStatus] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const dummyPayouts = [
        { id: 1, name: 'Ramesh Kumar', amount: 45000, status: 'Paid' },
        { id: 2, name: 'Sita Rani', amount: 42000, status: 'Pending' },
        { id: 3, name: 'Amit Joshi', amount: 50000, status: 'Failed' },
        { id: 4, name: 'Priya Mehta', amount: 47000, status: 'Paid' },
        { id: 5, name: 'Rohit Singh', amount: 43000, status: 'Pending' },
      ];
      setPayouts(dummyPayouts);
      setLoading(false);
    }, 1000);
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'Paid':
        return 'text-green-600 bg-green-100';
      case 'Pending':
        return 'text-yellow-600 bg-yellow-100';
      case 'Failed':
        return 'text-red-600 bg-red-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };

  const handleFilterChange = (e) => {
    setFilteredStatus(e.target.value);
  };

  const handleMarkAllAsPaid = () => {
    setLoading(true);
    setTimeout(() => {
      setPayouts((prev) =>
        prev.map((p) => (p.status !== 'Paid' ? { ...p, status: 'Paid' } : p))
      );
      setLoading(false);
    }, 1500); // simulate API delay
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handleExportCSV = () => {
    const headers = ['Employee', 'Amount', 'Status'];
    const rows = filteredPayouts.map((p) => [p.name, p.amount, p.status]);
    const csvContent = [headers, ...rows]
      .map((row) => row.join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'salary_disbursement.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const filteredPayouts = payouts.filter(
    (p) =>
      (filteredStatus === 'All' || p.status === filteredStatus) &&
      p.name.toLowerCase().includes(searchTerm)
  );

  return (
    <PayrollLayout title="Salary Disbursement">
      <div className='bg-white dark:bg-gray-900 font-poppins p-3 md:mx-0 mx-2 mb-2 rounded-xl'>
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-2">
          <div className="flex gap-2">
            <select
              onChange={handleFilterChange}
              value={filteredStatus}
              className="border dark:bg-black dark:border-gray-700 dark:text-white rounded px-3 py-2 text-sm"
            >
              <option value="All">All</option>
              <option value="Paid">Paid</option>
              <option value="Pending">Pending</option>
              <option value="Failed">Failed</option>
            </select>
            <input
              type="text"
              placeholder="Search employee"
              onChange={handleSearchChange}
              className="w-full border dark:bg-black dark:border-gray-700 dark:text-white rounded px-3 py-2 text-sm"
            />
          </div>

          <div className="flex gap-2">
            <button
              onClick={handleExportCSV}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm"
            >
              Export CSV
            </button>
            <button
              onClick={handleMarkAllAsPaid}
              disabled={loading}
              className={`${
                loading ? 'bg-green-300' : 'bg-green-600 hover:bg-green-700'
              } text-white px-4 py-2 rounded text-sm flex items-center`}
            >
              {loading ? (
                <span className="animate-spin mr-2 h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
              ) : null}
              Mark All as Paid
            </button>
          </div>
        </div>
      </div>
      
      {/* table data */}
      <div className="overflow-x-auto bg-white dark:bg-gray-900 shadow-md rounded-lg mx-2 font-poppins">
        <table className="min-w-full table-auto md:table-fixed text-sm">
          <thead className="bg-gray-100 dark:bg-gray-800 dark:text-white">
            <tr>
              <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Employee</th>
              <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Amount</th>
              <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="border-b hover:bg-gray-100 dark:hover:bg-gray-800">
                <td colSpan="6" className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                  <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-2 mt-2"></div>
                  {/* <p className="text-sm text-center text-gray-500">Loading reports...</p> */}
                </td>
              </tr>
            ) : filteredPayouts.length === 0 ? (
              <tr className="border-b hover:bg-gray-100 dark:hover:bg-gray-800">
                <td colSpan="6" className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">No reports found</td>
              </tr>
            ) : (
              filteredPayouts.map((p) => (
                <tr key={p.id} className="border-b dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800">
                  <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">{p.name}</td>
                  <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">₹{p.amount.toLocaleString()}</td>
                  <td className="p-3">
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusColor(p.status)}`}>
                      {p.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </PayrollLayout>
  );
}
